export default __webpack_public_path__ + "static/media/facebook-icn-about-mobile.319d3783.svg";